import { useState } from "react";
import { REPORT_REASONS } from "../../shared/limits.ts";
import { ApiError, api } from "../lib/api.ts";
import { useT } from "../lib/i18n.tsx";

/** Report a listing (R-TRS-5): reason + optional note. */
export function ReportSheet({ listingId, onClose }: { listingId: string; onClose: () => void }) {
  const t = useT();
  const [reason, setReason] = useState<(typeof REPORT_REASONS)[number]>("spam");
  const [note, setNote] = useState("");
  const [state, setState] = useState<"idle" | "busy" | "done" | "error">("idle");
  const [msg, setMsg] = useState<string | null>(null);

  async function submit() {
    setState("busy");
    try {
      await api(`/api/listings/${listingId}/report`, {
        body: { reason, ...(note.trim() ? { note: note.trim() } : {}) },
      });
      setState("done");
      setMsg(t("report.sent"));
    } catch (e) {
      setState("error");
      setMsg(
        e instanceof ApiError && e.status === 409
          ? t("report.sent")
          : e instanceof ApiError && e.status === 401
            ? t("error.unauthorized")
            : t("error.generic"),
      );
    }
  }

  return (
    <div className="sheet" role="dialog" aria-label={t("report.title")} data-testid="report-sheet">
      <strong>{t("report.title")}</strong>
      {state === "done" ? (
        <p className="ok">{msg}</p>
      ) : (
        <>
          <div className="chips">
            {REPORT_REASONS.map((r) => (
              <button
                key={r}
                type="button"
                className={`chip${reason === r ? " is-on" : ""}`}
                onClick={() => setReason(r)}
              >
                {t(`report.reason.${r}`)}
              </button>
            ))}
          </div>
          <textarea
            className="input"
            rows={3}
            maxLength={500}
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder={t("problem.note")}
          />
          {msg ? <p className="error">{msg}</p> : null}
        </>
      )}
      <div className="row">
        {state !== "done" ? (
          <button
            className="btn btn--accent"
            disabled={state === "busy"}
            onClick={() => void submit()}
            data-testid="report-submit"
          >
            {t("listing.report")}
          </button>
        ) : null}
        <button className="btn btn--ghost" onClick={onClose}>
          {t("common.close")}
        </button>
      </div>
    </div>
  );
}
